import { render, staticRenderFns } from "./event-date-badge.vue?vue&type=template&id=fb3e2b32"
import script from "./event-date-badge.vue?vue&type=script&lang=js"
export * from "./event-date-badge.vue?vue&type=script&lang=js"
import style0 from "./event-date-badge.vue?vue&type=style&index=0&id=fb3e2b32&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3e2b32')) {
      api.createRecord('fb3e2b32', component.options)
    } else {
      api.reload('fb3e2b32', component.options)
    }
    module.hot.accept("./event-date-badge.vue?vue&type=template&id=fb3e2b32", function () {
      api.rerender('fb3e2b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event-date-badge.vue"
export default component.exports